export class DataTableSavedBean {
  newList: any[];
  updatedList: any[];
  deletedList: number[];

  constructor() {
    this.newList = [];
    this.updatedList = [];
    this.deletedList = [];
  }
}
